import React, { Component } from 'react'
import LearningPage from '../../components/LearningPage/LearningPage';

class LearningRoute extends Component {
  render() {
    return (
      <section>
        <LearningPage/>
      </section>
    );
  }
}

export default LearningRoute
